import React, { useEffect } from 'react'
import $ from 'jquery'
import {
  isCellPhoneInPortrait,
  isCellPhone
} from '../Common'

let offsetX = 0;
let offsetY = 0;
let highZ = 10;

export const NextSteps = ({ data }) => {
  useEffect(() => {
    // This function will be called when the component mounts
    const handleComponentMount = () => {
      // Add your function logic here
      $('#popUpLink_process').bind('click', function () {
        popUp1Open()
      })

      $('#popup-content1, #popup-content1').on('drag', function (event) {
          $(event.target.id).css('cursor','move');
      })

      document.addEventListener("dragover", (event) => { //enables drag grab cursor
        event.preventDefault();
      });

      $('#popUpLink_cost').bind('click', function () {
        popUp2Open()
      })

      $('.close-button').bind('click', function (event) {
        let popup = event.target.parentElement.id
        if (popup === 'popup-content1') {
          popUp1Close()
        } else if (popup === 'popup-content2') {
          popUp2Close()
        }
      })
    }

    handleComponentMount()

    // If you need to clean up when the component unmounts, return a cleanup function
    return () => {
      console.log('Component will unmount')
      // Add your cleanup logic here if necessary
    }
  }) //, []) // The empty dependency array ensures this runs only once when the component mounts

  function popUp1Open (name) {
    var zIndex = $('#popup-content2').css("z-index");
    var zStr = ((zIndex *1) +2 ).toString();
    if(isCellPhone()){
      $('#popup-content1').css('display', 'block').css('z-index', zStr).css('left','0').css('width','310px').css('top','0');
    } else {
      $('#popup-content1').css('display', 'block').css('z-index', zStr).css('left','15%').css('width','500px').css('top','15%');
    }
    $('#popup1').fadeIn()
  }

  function popUp1Close () {
    console.log('got close1 click')
    $('#popup1').fadeOut()
  }

  function popUp2Open () {
    var zIndex = $('#popup-content1').css("z-index");
    var zStr = ((zIndex *1) +1 ).toString();
    console.log("cellphone: ", isCellPhone )
    if(isCellPhone()){
      $('#popup-content2').css('display','block').css('z-index',zStr).css('left','0').css('font-size','10px');
      $('#popup-content2').css('width','310px').css('padding-bottom','20px').css('top','0');
    
    } else {
      $('#popup-content2').css('display', 'block').css('z-index', zStr).css('left','15%').css('font-size','16px');
      $('#popup-content2').css('top','15%').css('width','500px').css('padding-bottom','10px');
    
    }
    $('#popup2').fadeIn()
  }

  function popUp2Close () {
    $('#popup2').fadeOut()
  }

  function handleDragStart (event) {
    offsetX = event.pageX - $(event.target).offset().left;
    offsetY = event.pageY - $(event.target).offset().top;

    if (event.target.id === 'popup-content1'){
      var zIndex = $('#popup-content2').css("z-index");
      var zStr = ((zIndex *1) +1 ).toString();
      $('#popup-content1').css('z-index', zStr);
    }
    if (event.target.id === 'popup-content2'){
      var zIndex = $('#popup-content1').css("z-index");
      var zStr = ((zIndex *1) +1 ).toString();
      $('#popup-content2').css('z-index', zStr);
    }

  }

  function handleDrop (event) {
    event.preventDefault();
    $(event.target.id).css('cursor','grab');
    const x = event.pageX
    const y = event.pageY
    $(event.target).css({
      top: y - offsetY + 'px',
      left: x - offsetX + 'px'
    })
  }

  return (
    <div
      style={{
        height: '100vh',
        overflowY: 'auto',
        paddingRight: '20px',
        width: '100%'
      }}
    >
      <div id='popup1' draggable='true'>
        <div
          id='popup-content1'
          draggable='true'
          onDragStart={handleDragStart}
          onDragEnd={handleDrop}
          style={{
            display: 'none',
            position: 'fixed',
            border: 'solid thin rgba(0, 107,235, 1.0)',
            zIndex: '10',
            top: '15%',
            aspectRatio: '15/ 16' /* Adjust to your desired aspect ratio */,
            width: '500px',
            background: 'rgba(234, 234, 255, 1.0)',
            maxWidth: '620px',
            backgroundImage: 'url("DoTell2ImplementationProcess.png")', // Replace with your image URL
            backgroundSize: '95%', // Ensure the image covers the entire div
            backgroundPosition: 'center center', // Center the image
            backgroundRepeat: 'no-repeat',
            cursor: 'grab'
          }}
          onClick={e => e.stopPropagation()}
        >
          <span
            className='close-button'
            style={{
              fontSize: '24px',
              float: 'right',
              paddingRight: '10px',
              cursor: 'pointer'
            }}
          >
            &times;
          </span>
          <br></br>
          <br></br>
          <p></p>
        </div>
      </div>

      <div id='popup2' >
        <div
          id='popup-content2'
          draggable='true'
          onDragStart={handleDragStart}
          onDragEnd={handleDrop}
          style={{
            display: 'none',
            position: 'fixed',
            paddingLeft: '30px',
            border: 'solid thin rgba(0, 107,235, 1.0)',
            zIndex: '10',
            top: '10%',
            width: '500px',
            //width: '100%',
            height: 'auto',
            //minHeight: '650px',
            background: 'rgba(234, 234, 255, 1.0)',
            cursor: 'grab'
          }}
          onClick={e => e.stopPropagation()}
        >
          <span
            className='close-button'
            style={{
              fontSize: '24px',
              float: 'right',
              paddingRight: '10px',
              cursor: 'pointer'
            }}
          >
            &times;
          </span>
          <br></br>
          <br></br>
          <div>
            <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
              DoTell Pricing
            </div>
            <div style={{ textAlign: 'center' }}>
              <i>(Based on the following components)</i>
            </div>
            <br></br>
            <span style={{ fontWeight: 'bold' }}>Proof of Concept</span>
            <br></br>
            <span style={{ marginLeft: '30px' }}>Sample of Item Types</span>
            <br></br>
            <span style={{ marginLeft: '30px' }}>Simple Checking</span>
            <br></br>
            <br></br>
            <span style={{ fontWeight: 'bold' }}>Integration with LMS</span>
            <br></br>
            <span style={{ marginLeft: '30px' }}># of Test Forms</span>
            <br></br>
            <span style={{ marginLeft: '30px' }}>
              Authentication Mode: Audio, pin, password, biometric
            </span>
            <br></br>
            <br></br>
            <span style={{ fontWeight: 'bold' }}>Equating</span>
            <br></br>
            <span style={{ marginLeft: '30px' }}># of items / test</span>
            <br></br>
            <span style={{ marginLeft: '30px' }}># of Anchor items </span>
            <br></br>
            <br></br>
            <span style={{ fontWeight: 'bold' }}>Item Complexity</span>
            <br></br>
            <span style={{ marginLeft: '30px' }}>
              Stimulus – Text, Audio, Video, Graphics{' '}
            </span>
            <br></br>
            <span style={{ marginLeft: '30px' }}>
              Response Analysis – Correct | Incorrect; Diagnostic
            </span>
            <br></br>
            <span style={{ marginLeft: '30px' }}>
              Reporting Detail – Correct | Incorrect; Diagnostic
            </span>
            <br></br>
            <br></br>
            <span style={{ fontWeight: 'bold' }}>Security</span>
            <br></br>
            <span style={{ marginLeft: '30px' }}>Remote Proctoring</span>
            <br></br>
            <span style={{ marginLeft: '30px' }}>Audio Sampling</span>
            <br></br>
            <span style={{ marginLeft: '30px' }}>Form Randomization</span>
            <br></br>
            <br></br>
            <span style={{ fontWeight: 'bold' }}>Payment Structure:</span>
            <br></br>
            <span style={{ marginLeft: '30px' }}>Initial Development Cost</span>
            <br></br>
            <span style={{ marginLeft: '30px' }}>Ongoing Maintenance </span>
            <br></br>
            <span style={{ marginLeft: '30px' }}>Support / quarter</span>
            <br></br>
            <span style={{ marginLeft: '30px' }}>
              Administration Price per 20{' '}
            </span>
            <br></br>
            <br></br>
            <div style={{ textAlign: 'left', paddingLeft:'20px' }}>
              <i>For pricing specifics, please email or call Wallace Judd</i>
            </div>
            <div style={{ textAlign: 'left', paddingLeft:'50px' }}>
              <i>wjudd@authentictesting.com, (530) 559-1478.</i>
            </div>
          </div>
        </div>
      </div>

      <div style={{ width: '70%', margin: 'auto' }}>
        <div
          style={{ marginTop: '80px', marginLeft: '20px', fontSize: '22px' }}
        >
          &nbsp;
        </div>
        <br></br>
        <div
          style={{
            position: 'relative',
            marginLeft: '40px',
            fontSize: '18px',
            color: 'black'
          }}
        >
          <p
            style={{
              marginTop: '30px',
              marginBottom: '8px',
              color: '#006bef'
            }}
          >
            <span style={{ fontSize: '22px' }}>
              <strong>Engagement</strong>
            </span>
          </p>
          <p style={{ lineHeight: '1.5' }}>
            <span>There are three primary use cases:</span>
          </p>

          <ul style={{ marginLeft: '60px' }}>
            <li style={{ lineHeight: '1.5' }}>
              <span>
                Readiness – is a candidate ready with the prerequisites for a
                course?
              </span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span>
                Success – has a candidate gotten the primary ideas from a
                chapter or course?{' '}
              </span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span>
                Currency – is a practitioner current in his/her professional
                information?
              </span>
            </li>
          </ul>

          <p
            style={{
              marginTop: '30px',
              marginBottom: '8px',
              color: '#006bef'
            }}
          >
            <span style={{ fontSize: '22px' }}>
              <strong>
                The first step in engagement is a feasibility study – Milestone
                1.
              </strong>
            </span>
          </p>
          <p>
            <span style={{ lineHeight: '1.5' }}>
              Is conversational testing an approach you’d like to discuss now?
            </span>
          </p>

          <ul style={{ marginLeft: '60px' }}>
            <li style={{ lineHeight: '1.5' }}>
              <span>Is a reservoir of candidates identified?</span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span>What’s the outcome of a quiz?</span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span>
                Do you have a set of 3-5 SMEs who can develop quiz questions and
                verify answers?
              </span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span>What problem are you solving:</span>
            </li>
            <ul style={{ marginLeft: '60px' }}>
              <li style={{ lineHeight: '1.5' }}>
                <span>
                  Readiness – encouraging candidates to take the next step
                  (course or cert)
                </span>
              </li>
              <li style={{ lineHeight: '1.5' }}>
                <span>
                  Success – How are candidates doing? Is the course successful?
                </span>
              </li>
              <li style={{ lineHeight: '1.5' }}>
                <span>Currency – keeping professionals current</span>
              </li>
            </ul>
            <li style={{ lineHeight: '1.5' }}>
              <span>
                Is the content clear? &nbsp;Are there objectively correct
                answers?
              </span>
            </li>
          </ul>

          <p
            style={{
              marginTop: '30px',
              marginBottom: '8px',
              color: '#006bef'
            }}
          >
            <span style={{ fontSize: '22px' }}>
              <strong>Next step: &nbsp;Proof of Concept – Milestone 2.</strong>
            </span>
          </p>
          <p
            style={{
              textIndent: '-20px',
              paddingLeft: '50px',
              lineHeight: '1.5'
            }}
          >
            <span style={{ lineHeight: '1.5' }}>
              Draft 10 – 15 items or conversational presentation
            </span>
          </p>

          <ul style={{ marginLeft: '60px' }}>
            <li style={{ lineHeight: '1.5' }}>
              <span>
                Correct and one incorrect answer drafted for each item
              </span>
            </li>
          </ul>

          <p
            style={{
              textIndent: '-20px',
              paddingLeft: '50px',
              lineHeight: '1.5',
              marginTop: '15px'
            }}
          >
            <span style={{ lineHeight: '1.5' }}>
              Test the draft with 10-15 &nbsp;candidates
            </span>
          </p>

          <ul style={{ marginLeft: '60px' }}>
            <li style={{ lineHeight: '1.5' }}>
              <span>Review responses</span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span>Add to incorrect response</span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span>Test scoring</span>
            </li>
          </ul>

          <p
            style={{
              textIndent: '-20px',
              paddingLeft: '50px',
              lineHeight: '1.5',
              marginTop: '15px'
            }}
          >
            <span style={{ lineHeight: '1.5' }}>
              Make recommendations for next step.
            </span>
          </p>

          <p
            style={{
              marginTop: '30px',
              marginBottom: '8px',
              color: '#006bef'
            }}
          >
            <span style={{ fontSize: '22px' }}>
              <strong>Next Step – Milestone 3. </strong>
            </span>
          </p>
          <ul style={{ marginLeft: '60px' }}>
            <li style={{ lineHeight: '1.5' }}>
              <span>Add feedback for multiple incorrect responses</span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span>Add / revise items </span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span>Implement scoring</span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span>QA with 20 candidates</span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span>Create invite letter, with link to quiz</span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <div
                id='popUpLink_process'
                style={{ color: 'blue', cursor: 'pointer' }}
              >
                <u>Click for additional details</u>
              </div>
            </li>
          </ul>
          <p>
            <span></span>
          </p>

          <p
            style={{
              marginTop: '30px',
              marginBottom: '8px',
              color: '#006bef'
            }}
          >
            <span style={{ fontSize: '22px' }}>
              <strong>Costs</strong>
            </span>
          </p>

          <ul style={{ marginLeft: '60px' }}>
            <li style={{ lineHeight: '1.5' }}>
              <span>Initial Basic Cost per 15-Item Test</span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span>Charges for custom graphics, audio</span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span>Cost per test administration</span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <div
                id='popUpLink_cost'
                style={{ color: 'blue', cursor: 'pointer' }}
              >
                <u>Click for cost structure</u>
              </div>
            </li>
          </ul>

          <br></br>
          <br></br>
          <br></br>
        </div>
      </div>
    </div>
  )
}
